import React, { memo } from 'react';

import IconMC from '../../../../../components/IconMC';

const DeliveryMethodSelector = ({
  icon,
  label,
  selected,
  onSelect
}) => (
  <button
    type="button"
    onClick={onSelect}
    className={`tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-4 tw-rounded-xl tw-border tw-p-4 tw-bg-white tw-cursor-pointer tw-text-left ${
      selected ? 'tw-border-[#198FCC]' : 'tw-border-[#E4E4E4]'
    }`}
  >
    <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-0">
      <img src={icon} alt="" className="tw-w-[30px] tw-h-[30px] tw-flex-shrink-0 tw-object-contain" />
      <span className="tw-text-sm tw-text-[#808191]">{label}</span>
    </div>

    <span
      className={`tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border ${
        selected
          ? 'tw-border-[#3CAAE1] tw-bg-[#3CAAE1]'
          : 'tw-border-[#B2BEC7] tw-bg-white'
      }`}
      aria-hidden
    >
      {selected && (
        <IconMC name="checkmark-outline" size="sm" className="tw-text-white" />
      )}
    </span>
  </button>
);

export default memo(DeliveryMethodSelector);
